import React from 'react'
import Spaces from '../spaces/Spaces'

const Submissions = () => {
  return (
    <div>
      <Spaces />
    </div>
  )
}

export default Submissions